import React from "react";
import { AuthProvider } from "./auth";
import { Beforeunload } from "react-beforeunload";

type Props = {
  children: JSX.Element;
};

const GlobalContext: React.FC<Props> = ({ children }) => {
  const rememberMe = localStorage.getItem("rememberMe");
  const token = localStorage.getItem("token");

  const onBeforeunload = () => {
    if (token) {
      localStorage.clear();
    }
  };

  return (
    <>
      {rememberMe === null && <Beforeunload onBeforeunload={onBeforeunload} />}
      <AuthProvider>{children}</AuthProvider>;
    </>
  );
};

export default GlobalContext;
